import { setPromptMessage, getPromptMessage } from '@/utils';

const app = {
  state: {
    newApp: true,
    customizeHeader: false,
    title: '',
    headerFixed: true,
    showBack: false,
    backText: '',
    backStyle: '',
    errorRequest: null,
    messageResponse: getPromptMessage(),
    showPopup: false,
    showInnerPopup: false,
    scrollToHideDownloadBar: false,
    downloadBarInfo: null,
    downloadBarKey: '',
    agencySettingBar: {
      show: false,
    },
    updateAppTokenCount: 0,
  },
  getters: {
    newApp: state => state.newApp,
    customizeHeader: state => state.customizeHeader,
    title: state => state.title,
    headerFixed: state => state.headerFixed,
    showBack: state => state.showBack,
    backText: state => state.backText,
    backStyle: state => state.backStyle,
    errorRequest: state => state.errorRequest,
    messageResponse: state => state.messageResponse,
    showPopup: state => state.showPopup,
    showInnerPopup: state => state.showInnerPopup,
    scrollToHideDownloadBar: state => state.scrollToHideDownloadBar,
    downloadBarInfo: state => state.downloadBarInfo,
    downloadBarKey: state => state.downloadBarKey,
    agencySettingBar: state => state.agencySettingBar,
    updateAppTokenCount: state => state.updateAppTokenCount,
  },
  mutations: {
    SET_NEW_APP: (state, data) => {
      state.newApp = data;
    },
    SET_CUSTOMIZE_HEADER: (state, data) => {
      state.customizeHeader = data;
    },
    SET_TITLE: (state, data) => {
      state.title = data;
    },
    SET_HEADER_FIXED: (state, data) => {
      state.headerFixed = data;
    },
    SET_SHOW_BACK: (state, data) => {
      state.showBack = data;
    },
    SET_BACK_TEXT: (state, data) => {
      state.backText = data;
    },
    SET_BACK_STYLE: (state, data) => {
      state.backStyle = data;
    },
    SET_ERROR_REQUEST: (state, data) => {
      state.errorRequest = data;
    },
    SET_MESSAGE_RESPONSE: (state, data) => {
      state.messageResponse = data;
    },
    SET_SHOW_POPUP: (state, data) => {
      state.showPopup = data;
    },
    SET_SHOW_INNER_POPUP: (state, data) => {
      state.showInnerPopup = data;
    },
    SET_SCROLL_TO_HIDE_DOWNLOAD_BAR: (state, data) => {
      state.scrollToHideDownloadBar = data;
    },
    SET_DOWNLOAD_BAR_INFO: (state, data) => {
      state.downloadBarInfo = data;
    },
    SET_DOWNLOAD_BAR_KEY: (state, data) => {
      state.downloadBarKey = data;
    },
    SET_AGENCY_SETTING_BAR: (state, data) => {
      state.agencySettingBar = data;
    },
    SET_UPDATE_APP_TOKEN_COUNT: (state, data) => {
      state.updateAppTokenCount = data;
    },
  },
  actions: {
    toggleNewApp({ commit }, payload) {
      commit('SET_NEW_APP', payload);
    },
    toggleCustomizeHeader({ commit }, payload) {
      commit('SET_CUSTOMIZE_HEADER', payload);
    },
    changeTitle({ commit }, payload) {
      commit('SET_TITLE', payload);
    },
    toggleHeaderFixed({ commit }, payload) {
      commit('SET_HEADER_FIXED', payload);
    },
    toggleShowBack({ commit }, payload) {
      commit('SET_SHOW_BACK', payload);
    },
    changeBackText({ commit }, payload) {
      commit('SET_BACK_TEXT', payload);
    },
    updateBackStyle({ commit }, payload) {
      commit('SET_BACK_STYLE', payload);
    },
    updateErrorRequest({ commit }, payload) {
      commit('SET_ERROR_REQUEST', payload);
    },
    updateMessageResponse({ commit }, payload) {
      setPromptMessage(payload);
      commit('SET_MESSAGE_RESPONSE', payload);
    },
    toggleShowPopup({ commit }, payload) {
      commit('SET_SHOW_POPUP', payload);
    },
    toggleShowInnerPopup({ commit }, payload) {
      commit('SET_SHOW_INNER_POPUP', payload);
    },
    toggleScrollToHideDownloadBar({ commit }, payload) {
      commit('SET_SCROLL_TO_HIDE_DOWNLOAD_BAR', payload);
    },
    toggleDownloadBarInfo({ commit }, payload) {
      commit('SET_DOWNLOAD_BAR_INFO', payload);
    },
    toggleDownloadBarKey({ commit }, payload) {
      commit('SET_DOWNLOAD_BAR_KEY', payload);
    },
    toggleAgencySettingBar({ commit }, payload) {
      commit('SET_AGENCY_SETTING_BAR', payload);
    },
    toggleUpdateAppTokenCount({ commit }, payload) {
      commit('SET_UPDATE_APP_TOKEN_COUNT', payload);
    },
  },
};

export default app;
